export function isHtml5Audio(stream) {
  return /.+\.(mp3|aac|ogg)(\?|$)/.test(stream);
}

export function isPlaylist(stream) {
  return /.+\.(m3u|pls|asx)(\?|$)/.test(stream);
}

export function isHls(stream) {
  return /.+\.m3u8(\?|$)/.test(stream);
}

export function possiblyShoutcast(stream) {
  return stream && !isHtml5Audio(stream) && !isPlaylist(stream) && !isHls(stream);
}

export function formatShoutcast(b) {
  const c = ';';
  const d = b.indexOf('?');
  const a = (e) => {
    if (e.endsWith(`/${c}`)) return e;
    if (e.endsWith('/')) return e + c;
    return `${e}/${c}`;
  };
  return d > -1 ? a(b.substring(0, d)) + b.substring(d) : a(b);
}
